import { useEffect, useState } from "react";

const DAY_NAMES = ["CHỦ NHẬT", "THỨ 2", "THỨ 3", "THỨ 4", "THỨ 5", "THỨ 6", "THỨ 7"];

export function pad(n: number): string {
  return n.toString().padStart(2, "0");
}

export interface ClockInfo {
  time: string;
  seconds: string;
  dateLabel: string;
  greeting: string;
}

export function useClock(): ClockInfo {
  const [now, setNow] = useState(new Date());

  useEffect(() => {
    const id = setInterval(() => setNow(new Date()), 1000);
    return () => clearInterval(id);
  }, []);

  const hour = now.getHours();
  const time = `${pad(hour)}:${pad(now.getMinutes())}`;
  const seconds = `:${pad(now.getSeconds())}`;
  const session = hour < 12 ? "SÁNG" : hour < 18 ? "CHIỀU" : "TỐI";
  const dateLabel = `TP.HCM, ${session} ${DAY_NAMES[now.getDay()]}, ${pad(now.getDate())}/${pad(
    now.getMonth() + 1
  )}/${now.getFullYear()}`;
  const greeting = hour < 12 ? "Chào buổi sáng" : hour < 18 ? "Chào buổi chiều" : "Chào buổi tối";

  return { time, seconds, dateLabel, greeting };
}
